import React, { memo, useContext, useCallback } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

// TODO Add equivalent icon to DS and use here
import TableIcon from 'mdi-react/ViewColumnIcon';

import { LayoutMode } from './types';

import * as S from './styles';
import {
  IconViewCompactList,
  IconViewGrid,
  IconViewList,
} from '@prisjakt/ui/icon';
import { IconProps } from '@prisjakt/ui/icon/types';
import { useTheme } from 'styled-components';

type Props = {
  mode: LayoutMode;
  active: boolean;
  onClick: (mode: LayoutMode) => void;
};

const LayoutPicker = ({ mode, onClick, active }: Props) => {
  const { t } = useContext(AppContext);
  const theme = useTheme();
  const iconColor = (active
    ? theme.icons.primary
    : theme.icons.secondary) as IconProps['color'];

  const setListMode = useCallback(() => onClick(mode), [mode, onClick]);

  return (
    <S.LayoutButton
      onClick={setListMode}
      aria-label={t(
        'category',
        mode === LayoutMode.GRID
          ? 'product-list.grid-layout-button'
          : 'product-list.list-layout-button'
      )}
      active={active}
      data-test={`layout-button-${mode}`}
    >
      <Icon mode={mode} color={iconColor} />
    </S.LayoutButton>
  );
};

const Icon = ({
  mode,
  color,
}: {
  mode: LayoutMode;
  color: IconProps['color'];
}) => {
  switch (mode) {
    case LayoutMode.GRID:
      return <IconViewGrid color={color} />;
    case LayoutMode.LIST:
      return <IconViewList color={color} />;
    case LayoutMode.TABLE:
      return <TableIcon size={24} color={color} />;
    case LayoutMode.COMPACT_LIST:
      return <IconViewCompactList color={color} />;
    default:
      return <IconViewList color={color} />;
  }
};

export default memo(LayoutPicker);
